import './index.scss';
import paymentImage from '../../../assets/images/secondBlock/payment/Payment.png';
import votingImage from '../../../assets/images/secondBlock/payment/Voting.png';
import coin from '../../../assets/videos/secondPage/Coin.mp4';
import coinMobile from '../../../assets/videos/secondPage/CoinMobile.mp4';
import useViewportSize from "../../../hooks/useViewportSize";
import {useInViewport} from "react-in-viewport";
import {useEffect, useRef, useState} from "react";
import classNames from "classnames";

export default function Payment({ loaded }) {
    const [showComponent, setShowComponent] = useState(false);
    const componentRef = useRef();
    const coinVideo = useRef();

    const ViewportSize = useViewportSize();

    const { inViewport } = useInViewport(componentRef, { threshold: ViewportSize.width > 1000 ? 0.25 : 0.05 });
    const { inViewport: inViewportVideo } = useInViewport(coinVideo, { threshold: 0.01 });

    useEffect(() => {
        if (!loaded) return;
        if (!inViewport || (inViewport && showComponent)) return;
        setShowComponent(true);
    }, [inViewport, loaded]);

    useEffect(() => {
        if (!loaded) return;
        if (!inViewportVideo || (inViewportVideo && !coinVideo.current.paused)) return;
        coinVideo.current.play();
    }, [inViewportVideo, loaded]);

    return (
        <div
          ref={componentRef}
          id='payment'
          className={classNames('paymentMain', showComponent && 'show')}
        >
            <div className='paymentMain-images'>
                <div className='paymentMain-images-paymentImg'>
                    <h2 className="gradient-heading">Redefining Play and Ownership</h2>
                    {/*<img src={paymentImage} alt='paymentImage' />*/}
                {/*</div>*/}
                {/*<div className='paymentMain-images-votingImg'>*/}
                {/*    <img src={votingImage} alt='votingImage' />*/}
                </div>
            </div>

            <div className='paymentMain-content'>
                <div className='paymentMain-content-textWrapper'>
                    <p className='paymentMain-content-textWrapper-text'>
                        We’re experimenting with how Web3 technology can enhance the gaming experience—not as a core focus, but as an exciting layer in select projects. Our aim isn’t to turn every game into a Web3 showcase but to explore how decentralized systems can add depth, ownership, and curiosity to the worlds we build.
                    </p>
                    <p className='paymentMain-content-textWrapper-text'>These experiments bridge traditional gaming with the emerging Web3 ecosystem. For players, this means owning in-game assets that truly belong to them, participating in player-driven economies, or being rewarded through thoughtful, healthy incentives. But our priority remains the same: creating games that are fun, immersive, and worth playing even without the tech.</p>
                    <p className='paymentMain-content-textWrapper-text'>
                        By blending Web3’s potential with accessible, high-quality gameplay, we’re working to bridge the gap between commercial gamers and DeFi enthusiasts. It’s not about exclusivity—it’s about making Web3 feel intuitive and exciting for anyone, sparking curiosity without compromising what matters most: the game itself.
                    </p>
                    {/*<p className='paymentMain-content-textWrapper-text'>Every week <span className='changing-color'>LMS</span> holders can connect to the dashboard and vote for the token they wish to receive that week.</p>*/}
                </div>
                <div className='paymentMain-content-coinVideo'>
                    <video ref={coinVideo} className="paymentMain-content-video" width="100%" height="100%" loop playsInline muted>
                        <source src={ViewportSize.width > 500 ? coin : coinMobile} type="video/mp4" />
                    </video>
                </div>
            </div>
        </div>
    )
}
